import Autosuggest from "react-autosuggest";
import "./Autosuggest.css";
import { css, errorStyle } from "./SKT";
import { Fragment, useState } from "react";
import { useAPI } from "../hooks/APIHook";
import { SKTBaseComponent } from "./SKTBaseComponent";
import { API_ENDPOINTS } from "../config";

export const SKTAutocompleteTextField = ({
  id,
  label,
  placeholder,
  data,
  includeSE,
  showFlags,
}) => {
  const onchange = (event, { newValue }) => {
    if (newValue === undefined) return;
    data.set(id, newValue);
  };
  const onblur = ({ highlightedSuggestion }) => {
    const currentValue = data.get(id);
    if (currentValue === undefined) return;
    const guessSuggestion = () => {
      const suggestions = getSuggestions(currentValue);
      if (suggestions.length !== 1) return undefined;
      return suggestions[0];
    };
    const s = highlightedSuggestion ?? guessSuggestion();
    if (s !== undefined) {
      data.set(id, getSuggestionValue(s));
    } else {
      data.set(id, "");
    }
  };

  const endpoint = includeSE
    ? API_ENDPOINTS.postalCodes.both
    : API_ENDPOINTS.postalCodes.fi;
  const [postalCodeData] = useAPI(endpoint);
  const postalCodes =
    postalCodeData.status === "ok" ? postalCodeData.codes : [];

  // Teach Autosuggest how to calculate suggestions for any given input value.
  const getSuggestions = (value) => {
    const inputValue = value.trim().toUpperCase();
    const inputLength = inputValue.length;
    if (inputLength === 0) return [];
    const result = postalCodes.filter(
      (postalCode) =>
        postalCode.name.slice(0, inputLength) === inputValue ||
        postalCode.code.slice(0, inputLength) === inputValue
    );
    if (result.length === 0) {
      return postalCodes.filter(
        (postalCode) => getSuggestionValue(postalCode) === inputValue
      );
    }
    return result.slice(0, 20);
  };

  // When suggestion is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.
  const countryFlag = {
    FI: "\u{1F1EB}\u{1F1EE}",
    SE: "\u{1F1F8}\u{1F1EA}",
  };

  const getSuggestionValue = (suggestion) => {
    if (showFlags) {
      return `${countryFlag[suggestion.country]} ${suggestion.code} ${
        suggestion.name
      }`;
    }
    return `${suggestion.code} ${suggestion.name}`;
  };

  const CountryFlag = ({ country }) => {
    const flag = countryFlag[country] ?? "";
    return <span>{showFlags ? flag : ""}</span>;
  };

  // Use your imagination to render suggestions.
  const renderSuggestion = (suggestion) => (
    <div>
      <CountryFlag country={suggestion.country} />
      {suggestion.code} {suggestion.name}
    </div>
  );

  const inputProps = {
    className: css("form-control data zip"),
    id: id,
    name: id,
    placeholder: placeholder,
    type: "text",
    value: data.get(id) ?? "",
    onChange: onchange,
    onBlur: onblur,
    style: errorStyle(data.isValid(id)),
  };

  const [suggestions, setSuggesions] = useState([]);

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggesions(getSuggestions(value));
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
    setSuggesions([]);
  };

  return (
    <SKTBaseComponent data={data} id={id} label={label}>
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onchange}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      />
    </SKTBaseComponent>
  );
};
